import type { ReactNode } from 'react';
import { AssetMarketplace } from '../../../components/marketplace';
import PersonaEditor from '../../../components/PersonaEditor';
import { ensureConfig } from '../../../components/personaConfig';
import type { PersonaConfigData } from '../../../components/personaConfig';
import type { MarketplaceAsset } from '../../../types/marketplace';

export interface PersonaPanelProps {
  /** 当前激活 Profile 的人设配置（原始 JSON）。 */
  personaConfig: Record<string, unknown> | null;
  /** 人设模板资产（模板市场数据源）。 */
  assets: MarketplaceAsset[];
  /** 保存人设配置。 */
  onSave: (data: object) => void;
  /** 应用模板市场资产（页面内查找模板并调用 apply-template）。 */
  onToggle: (asset: MarketplaceAsset) => void;
  /** 人设在线服务工具栏节点。 */
  toolbar: ReactNode;
}

/** 人设维度面板：当前人设编辑 + 在线服务工具栏 + 从模板市场选择人设。 */
export default function PersonaPanel({ personaConfig, assets, onSave, onToggle, toolbar }: PersonaPanelProps) {
  return (
    <div className="flex flex-col gap-4">
      <div>
        <h3 className="mb-3">当前人设</h3>
        <PersonaEditor
          value={ensureConfig((personaConfig || {}) as Partial<PersonaConfigData>)}
          onChange={(data) => onSave(data)}
        />
      </div>
      {toolbar}
      <div className="card" style={{ background: 'var(--bg-primary)' }}>
        <AssetMarketplace
          assets={assets}
          initialType="persona"
          title="从模板市场选择人设"
          hideTypeFilter
          applyLabel="应用"
          onToggle={onToggle}
        />
      </div>
    </div>
  );
}
